import SiteConfig from '@/SiteConfig'
import UtilityHelper from '@/helpers/UtilityHelper'
import { reactive } from 'vue'

const ERROR_USING_DEFAULT_TRANSLATIONS = 'Locale was not found! Using default translations'
const DEFAULT_LOCALE = 'de-DE'

type Dictionary = Record<string, string>

const TRANSLATION_FILES = import.meta.glob<{ default: Dictionary }>('/src/assets/translations/*.json')

interface TranslationState {
  locale: string
  prefix: string
  translations: Dictionary
}

const state = reactive<TranslationState>({
  locale: '',
  prefix: '',
  translations: {}
})

export const fetchTranslations = async (): Promise<void> => {
  let locale = SiteConfig.locale

  if (!locale) {
    console.error(ERROR_USING_DEFAULT_TRANSLATIONS)
    locale = DEFAULT_LOCALE
  }
  state.locale = locale
  state.prefix = SiteConfig.translationPrefix

  const { default: translations } = await TRANSLATION_FILES[`/src/assets/translations/${state.locale}.json`]()
  state.translations = translations
}

export const translate = (key: string, ...data: string[]): string => {
  const template = state.translations[state.prefix + key] ?? state.translations[key]
  if (!template) return key

  return data.length ? UtilityHelper.formatString(template, ...data) : template
}

export default state
